export default __webpack_public_path__ + "static/media/Create-documentation.c2e9d29e.md";